/* unplugin-vue-components disabled */import { render } from "./EmptySpace.vue.js?vue&type=template&id=c6cf1a2c!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./EmptySpace.vue?vue&type=template&id=c6cf1a2c"
const script = {}

import exportComponent from "../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__